
export const getCongratulationHeading = async (data ={}) => {
    
const setTxtV2= (await import(/* webpackPrefetch: true */ `../../classes/universal_methods/setTxtV2.js`)).setTxtV2;
    
    let {heading, txt, icon, color} = data;
    icon = icon || "check-circle1";
    color = color || "success";

    return `
        <div>
        
            <h4 class="smetio-h4-heading smetio-margin-top-20 smetio-text-center smetio-${color}-text">
                <i class="smetio-icon smetio-icon-${icon}"></i>
            </h4>

            <h4 class="smetio-h4-heading smetio-margin-top-10 smetio-text-center smetio-${color}-text">
                ${ setTxtV2({ attributes: {}, txt: heading || "txt118", type: "html"}) }
            </h4>

            <p class=" smetio-h5-heading smetio-margin-top-30"> ${ setTxtV2({ attributes: {}, txt, type: "html"}) } </p>    
        </div>
    `;
};
